import "./Footer.css";
import Logo from "../../../../ui/atoms/logo/Logo";
import { FaLock } from "react-icons/fa";

const COLUMNS = [
  {
    title: "The tool",
    links: [
      "Features",
      "Mobile App",
    ],
  },
  {
    title: "Ressources",
    links: ["Help Center", "Guide", "Community"],
  },
  {
    title: "The School",
    links: [
      "About",
      "Contact",
      "Terms of Use",
      "Privacy Policy",
      "Copyright",
      "Trademarks",
      "Non-Discrimination",
      "Accessibility",
    ],
  },
];

// About Us
// Contact
// Terms of Use
// Privacy Policy
// Copyright
// Trademarks
// Non-Discrimination
// Accessibility

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container footer-inner">
        <div className="footer-brand">
          <Logo logo="masomo_logo_white.png" to={"/"} width={"140px"} />
          <p>
            The inclusive digital school for all — in rural, urban, and peri-urban
            communities — with or without an Internet connection.
          </p>
          <div className="footer-social" aria-label="Réseaux sociaux">
            <a href="#" aria-label="Facebook">
              <svg viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M14 9h3V6h-3c-2.2 0-4 1.8-4 4v2H8v3h2v6h3v-6h3l1-3h-4v-2c0-.6.4-1 1-1Z"
                />
              </svg>
            </a>
            <a href="#" aria-label="Instagram">
              <svg viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M8 3h8a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5V8a5 5 0 0 1 5-5Zm0 2a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H8Zm4 3a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm4.5-3.2a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"
                />
              </svg>
            </a>
            <a href="#" aria-label="YouTube">
              <svg viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M21.6 7.2s-.2-1.5-.8-2.1c-.8-.8-1.7-.8-2.1-.9C15.9 4 12 4 12 4s-3.9 0-6.7.2c-.4 0-1.3.1-2.1.9-.6.6-.8 2.1-.8 2.1S2.2 9 2.2 10.7v1.6c0 1.8.2 3.5.2 3.5s.2 1.5.8 2.1c.8.8 1.8.8 2.3.9 1.7.2 7 .2 7 .2s3.9 0 6.7-.3c.4 0 1.3-.1 2.1-.9.6-.6.8-2.1.8-2.1s.2-1.7.2-3.5v-1.6c0-1.7-.2-3.5-.2-3.5ZM9.9 14.6V8.9l5.4 2.9-5.4 2.8Z"
                />
              </svg>
            </a>
          </div>
        </div>

        {COLUMNS.map((col) => (
          <div className="footer-col" key={col.title}>
            <h4>{col.title}</h4>
            <ul>
              {col.links.map((link) => (
                <li key={link}>
                  <a href="#">{link}</a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="footer-container footer-bottom">
        <p>© {new Date().getFullYear()} MASOMO. All rights reserved.</p>
        <div className="footer-secure">
          <FaLock className="icon" />
          <span>Secured with SSL</span>
        </div>
        <p>Built with ❤️ to make education accessible for everyone.</p>
        {/* <p>Fait avec ❤️ pour rendre l'éducation accessible à tous.</p> */}
      </div>
    </footer>
  );
}
